
import { DEFAULT_SETTINGS } from '@xeetr/types/defaults'
import { Settings } from '@xeetr/types/models'
import { FormProvider, useForm } from 'react-hook-form'

import SettingsPage from '../../pages/Settings'

const SettingsProvider = () => {
  const methods = useForm<Settings>({ defaultValues: DEFAULT_SETTINGS })
  return (
    <FormProvider {...methods}>
      <SettingsPage />
    </FormProvider>
  )
}

export default SettingsProvider
